import { Pkg } from '@/api/pkg/types/Pkg'
import { UserPkg } from '@/api/user-package/types/UserPkg'

export const getPrice = (item: UserPkg | Pkg, EURToUSD: number, GBPToUSD: number, AEDToUSD: number): string => {
  let conversionRate: number
  switch (item.warehouse) {
    case 'GR':
      conversionRate = EURToUSD
      break
    case 'USA':
      conversionRate = 1
      break
    case 'UK':
      conversionRate = GBPToUSD
      break
    case 'UAE':
      conversionRate = AEDToUSD
      break
    default:
      conversionRate = 1
  }

  const price = ((item.price || 0) * conversionRate).toFixed(2)
  return price
}
